module.exports = __webpack_public_path__ + "media/images/logo-sfa2-4f1134a2137d1fd3ccfe7c003cfd9eb5.png";